import { AppThemeName } from '@cp/ds';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface ThemeState {
  name: AppThemeName;
}

const reducerPath = 'theme';
const initialState: ThemeState = {
  name: 'light',
};

const themeSlice = createSlice({
  name: '@@app/theme',
  initialState,
  reducers: {
    setTheme(state, action: PayloadAction<ThemeState['name']>): void {
      state.name = action.payload;
    },
  },
});

export const reducerConfig = {
  [reducerPath]: themeSlice.reducer,
};
export type ReducerStateShape = { [reducerPath]: ThemeState };
export const themeNameSelector = (state: ReducerStateShape) => state[reducerPath].name;
